import { Button } from "../../../components/common";
import { Icon } from "@iconify/react";
import { useLocalePath } from "../../../hooks/useLocalePath";
import { useTranslation } from "../../../i18n/I18nContext";
import { LANDING_MAX, LANDING_PAD_X } from "./landingLayout";

export function LandingPromBiz() {
  const lp = useLocalePath();
  const { t } = useTranslation();
  const bullets = [
    t("prombizForBusiness.bullet1"),
    t("prombizForBusiness.bullet2"),
    t("prombizForBusiness.bullet3"),
    t("prombizForBusiness.bullet4"),
  ];

  return (
    <section id="prombiz-for-business" className="relative w-full overflow-hidden bg-[#FCFCFE]">
      {/* Full-bleed blue glow — spans the entire section width (left column text sits on soft gradient too) */}
      <img
        src="/images/devices_bg.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-90"
      />
      {/* Soft fade on top of the glow to keep text readable */}
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_145%_92%_at_68%_50%,rgba(199,210,254,0.15)_0%,rgba(252,252,254,0.2)_52%,rgba(252,252,254,0.55)_100%)]"
        aria-hidden
      />
      <div className={`relative z-[1] ${LANDING_MAX} ${LANDING_PAD_X} py-12 sm:py-16 lg:py-[88px]`}>
        <div className="flex flex-col items-stretch gap-10 lg:flex-row lg:items-stretch lg:gap-14">
          <div className="flex w-full flex-col gap-5 lg:w-1/2 lg:gap-6">
            <h2 className="font-bold text-[#0F172A] text-[32px] leading-[120%] sm:text-[40px] lg:text-[52px]">
              PromBiz <span className="text-primary">{t("prombizForBusiness.headlineHighlight")}</span>
            </h2>
            <p className="text-base leading-[170%] text-[#4B5563] sm:text-lg">{t("prombizForBusiness.lead")}</p>

            <div className="flex flex-col gap-3 sm:gap-4">
              {bullets.map((item, i) => (
                <div key={i} className="flex flex-row items-center gap-3">
                  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-blur-01">
                    <Icon icon="mdi:check" className="h-3 w-3 text-primary" />
                  </div>
                  <span className="font-medium text-[#374151] text-sm">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-2 pt-1">
              <Button
                variant="primary"
                label={t("prombizForBusiness.cta")}
                icon="mdi:arrow-right"
                iconDirection="right"
                to={`${lp("/register")}?role=business`}
                className="mt-1 w-full rounded-[12px] sm:w-auto sm:self-start"
              />
              <div className="flex items-center gap-2 text-[#0F172A]">
                <span className="font-semibold text-sm sm:text-base">{t("prombizForBusiness.excellentLine")}</span>
                <div className="flex gap-0.5" aria-hidden>
                  {[1, 2, 3, 4, 5].map((s) => (
                    <img key={s} src="/icons/review_star.svg" alt="" aria-hidden className="h-4 w-4" />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="relative flex w-full min-h-0 items-center justify-center lg:w-1/2 lg:min-h-[520px]">
            <img
              src="/images/devices.webp"
              alt="PromBiz dashboard on laptop and mobile"
              className="relative h-auto w-full max-w-[640px] object-contain drop-shadow-[0_20px_40px_rgba(27,81,236,0.25)]"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
